<template>
  <div class="course-wrapper">
    <div class="course-content">
      <div class="main-title">
        <div class="link-list">
          <span class="text">{{ menu.menu_name }}</span>
        </div>
        <a
          :href="`/courseList.html?type=2&name=${menu.menu_name}&menuId=${menu.id}`"
          class="more-btn"
          style="margin-top: 6px"
        >
          <span class="btn-text">查看全部</span>
          <i class="iconfont icongengduo"></i>
        </a>
      </div>
      <div class="course-list">
        <template v-if="homeCourseList && homeCourseList.length">
          <CourseCard
            class="home-course-card"
            :info="course"
            v-for="course in homeCourseList"
            :key="course.courseId"
            :show-label="true"
            :userInfo="userInfo"
            :authType="authType"
          >
          </CourseCard>
        </template>
        <div v-else class="no-data">
          <Empty />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CourseCard from "./../../components/SpocCourseCard.vue";
import { Empty } from 'zhs-components'
export default {
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    }
  },
  components: {
    CourseCard,
    Empty
  },
  created() {
    this.getAuth()
    this.getHomeCourseList();
    console.log(this.authType);
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: this.$config.abbr,
      classId: undefined,
      authType: 0
    };
  },
  methods: {
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeSpoc({
        num: this.menu.num,
        menu_id: this.menu.id 
      });
      this.homeCourseList = homeCourse;
    },
    async getAuth() {
      const res2 = await this.$http.getConfigList()
      this.authType = res2.find(item => item.code == '10402') ? res2.find(item => item.code == '10402').auth_type : 0
    }
  },
  
};
</script>

<style lang="scss" scoped>
.course-wrapper {
  position: relative;
  min-height: 230px;
  margin: 0 auto;
  padding: 30px 0 30px;
  // background-color: #F5F5F5;
  // background: url('~assets/images/home/spoc_bg.jpg') no-repeat bottom;
  background-size: cover;
  .course-content {
    margin: 0 auto;
    width: 1200px;
    // height: 587px;
    // padding-top: 30px;
  }
}
.course-wrapper,
.notice-wrapper {
  vertical-align: top;
}

// .course-wrapper {
//   &:first-child {
//     // margin-bottom: 40px;
//   }
// }

.course-wrapper .course-list {
  // margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
}
.home-course-card {
  width: 284px;
}
.category {
  display: inline-block;
  max-width: 140px;
  margin-left: 8px;
}
.main-title {
  display: flex;
  height: 28px;
  // overflow: hidden;
  .link-list {
    flex: 1;
    // margin-top: 6px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    .text {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      letter-spacing: 1px;
    }
  }
  .more-btn {
    flex: 0 0 74px;
    margin-right: 0;
  }
}
</style>